module.exports = require("@adc/blueprint");